import { Input, Tooltip, Typography } from "antd";

const { Title } = Typography;
const { Search } = Input;

const AdminConsoleHeader = () => {
    return (
        <div className="flex gap-2">
            <Title level={3} className="!mb-0">
                Admin Console
            </Title>
            <div className="flex flex-1 content-center">
                <Tooltip title="Search for a tenant via anything">
                    <Search placeholder="Search" allowClear style={{ maxWidth: "50rem" }} />
                </Tooltip>
            </div>
        </div>
    );
};

export default AdminConsoleHeader;
